import React, { PureComponent } from 'react';

import { DisplayComponent } from 'formlabs-web-components/BaseComponents';
import { Link } from 'formlabs-web-components/Link';
import { Grid, Cell } from 'formlabs-web-components/Grid';

import ReactTable from 'react-table';
import 'react-table/react-table.css';

import './CareersTeamsList.module.css';
import './CareersTable.css';

const CareersTeamsList = DisplayComponent(
  class CareersTeamsList extends PureComponent {
    constructor(props) {
      super(props);
      this.state = {
        rows: 0,
        filtered: [],
        pageSize: 0,
        jobsList: [],
        teams: [],
        locations: [],
        default_values: {}
      };
      this.reactTable = React.createRef();
    }
    onTableViewChange() {
      if (this.reactTable.current) {
        const allData = this.reactTable.current.getResolvedState().sortedData;
        this.setState({ pageSize: allData.length });
        document.getElementsByClassName('rt-tbody')[0].scrollTop = 0;
      }
    }
    externalFilter(value, event) {}

    UNSAFE_componentWillMount() {
      let teamSelect = this.props.team;
      let locationSelect = this.props.location;
      let locationsList = this.props.locationsList;
      const { types } = this.props;
      let jobsFix = [];
      let locationOptions = [];
      let teamOptions = [];
      let typeOptions = [];
      let allJobs = this.props.teams;
      let default_values = {
        locations: 'all',
        teams: 'all',
        types: 'all'
      };
      // FIXME should use ".each" when mutating
      // eslint-disable-next-line array-callback-return
      allJobs.map(team => {
        if (teamSelect.indexOf(team.id.toString()) > -1) {
          // eslint-disable-next-line array-callback-return
          team.jobs.map(job => {
            // eslint-disable-next-line array-callback-return
            locationsList.offices.map(location => {
              if (job.location.name === location.name) {
                job.location.id = location.id;
              } else if (!job.location.id) {
                job.location.id = 0;
              }
            });

            if (
              locationSelect.includes(job.location.id.toString()) &&
              types.includes(job.metadata[0].value)
            ) {
              jobsFix.push({
                title: job.title,
                team: team.name,
                location: job.location.name,
                type: job.metadata[0].value,
                id: job.id
              });
              if (
                !locationOptions.filter(
                  location => location.name === job.location.name
                ).length
              ) {
                locationOptions.push({
                  id: job.location.id,
                  name: job.location.name
                });
              }
              if (!teamOptions.filter(t => t.name === team.name).length) {
                teamOptions.push({ id: team.id, name: team.name });
              }
              if (
                !typeOptions.filter(t => t.value === job.metadata[0].value)
                  .length &&
                job.metadata[0].value
              ) {
                typeOptions.push({ value: job.metadata[0].value });
              }
            }
          });
        }
      });
      if (locationOptions.length === 1) {
        default_values['locations'] = locationOptions[0].name;
      }
      if (teamOptions.length === 1) {
        default_values['teams'] = teamOptions[0].name;
      }
      if (typeOptions.length === 1) {
        default_values['types'] = typeOptions[0].value;
      }
      const alphabetizeByName = (a, b) => {
        if (a.name > b.name) {
          return 1;
        }
        return -1;
      };
      this.setState({
        pageSize: jobsFix.length,
        jobsList: jobsFix,
        locations: locationOptions.sort(alphabetizeByName),
        teams: teamOptions.sort(alphabetizeByName),
        types: typeOptions,
        default_values: default_values
      });
    }

    render() {
      return (
        <Grid direction="x" className="careers">
          <Cell largeSize="24">
            <ReactTable
              data={this.state.jobsList}
              filterable
              resizable={false}
              ref={this.reactTable}
              noDataText="No Jobs Found"
              onFilteredChange={this.onTableViewChange.bind(this)}
              onResizedChange={this.onTableViewChange.bind(this)}
              columns={[
                {
                  Header: 'Job Title',
                  accessor: 'title',
                  minWidth: 240,
                  className: 'job-title',
                  filterable: false,
                  resizable: false,
                  Cell: row => (
                    <Link to={`/job/${row.original.id}/apply`}>
                      {row.value}
                    </Link>
                  )
                },
                {
                  Header: 'Team',
                  accessor: 'team',
                  className: 'team',
                  minWidth: 165,
                  resizable: false,
                  filterMethod: (filter, row) => {
                    if (filter.value === 'all') {
                      return true;
                    }
                    return row[filter.id] === filter.value;
                  },
                  Filter: ({ filter, onChange }) => (
                    <div>
                      {this.state.teams.length > 0 && (
                        <select
                          onBlur={event => onChange(event.target.value)}
                          onChange={event => onChange(event.target.value)}
                          style={{ width: '100%' }}
                          value={
                            filter
                              ? filter.value
                              : this.state.default_values['teams']
                          }
                          aria-label="Team"
                        >
                          <option value="all">Filter By Team</option>
                          {this.state.teams.map(team => {
                            return (
                              <option key={team.id} value={team.name}>
                                {team.name}
                              </option>
                            );
                          })}
                        </select>
                      )}
                    </div>
                  )
                },
                {
                  Header: 'Location',
                  accessor: 'location',
                  className: 'location',
                  minWidth: 165,
                  resizable: false,
                  filterMethod: (filter, row) => {
                    if (filter.value === 'all') {
                      return true;
                    }
                    return row[filter.id] === filter.value;
                  },
                  Filter: ({ filter, onChange }) => (
                    <div>
                      {this.state.locations.length > 0 && (
                        <select
                          onBlur={event => onChange(event.target.value)}
                          onChange={event => onChange(event.target.value)}
                          style={{ width: '100%' }}
                          defaultValue={
                            filter
                              ? filter.value
                              : this.state.default_values['locations']
                          }
                          aria-label="Location"
                        >
                          <option value="all">Filter By Location</option>
                          {this.state.locations.map(location => {
                            return (
                              <option key={location.id} value={location.name}>
                                {location.name}
                              </option>
                            );
                          })}
                        </select>
                      )}
                    </div>
                  )
                },
                {
                  Header: 'Type',
                  accessor: 'type',
                  className: 'type',
                  minWidth: 165,
                  resizable: false,
                  filterMethod: (filter, row) => {
                    if (filter.value === 'all') {
                      return true;
                    }
                    return row[filter.id] === filter.value;
                  },
                  Filter: ({ filter, onChange }) => (
                    <div>
                      {this.state.types.length > 0 && (
                        <select
                          onBlur={event => onChange(event.target.value)}
                          onChange={event => onChange(event.target.value)}
                          style={{ width: '100%' }}
                          value={
                            filter
                              ? filter.value
                              : this.state.default_values['types']
                          }
                          aria-label="Type"
                        >
                          <option value="all">Filter By Type</option>
                          {this.state.types.map(type => {
                            return (
                              <option key={type.value} value={type.value}>
                                {type.value}
                              </option>
                            );
                          })}
                        </select>
                      )}
                    </div>
                  )
                }
              ]}
              pageSize={this.state.pageSize}
              showPagination={false}
              // sortable={false}
            />
          </Cell>
        </Grid>
      );
    }
  }
);

export default CareersTeamsList;
